import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { Subscription } from 'rxjs';
import { MenuService } from './app.menu.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
@TraceClassDecorator()
export class AppMenuComponent implements OnInit, OnDestroy {

    subscription: Subscription;
    model: any[];
    name: string;

    constructor(public dataService: MenuService) {
        this.subscription = dataService.itemsHandler.subscribe(response => {
            this.model = response;
        });

        this.subscription = dataService.nameHandler.subscribe(response => {
            this.name = response;
        });
    }

    ngOnInit() {

    }

    isIE() {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

}
